window.GeometryAlgolia = window.GeometryAlgolia || {};

window.GeometryAlgolia.minSearchQueryLength = window.GeometryAlgolia.minSearchQueryLength || 3;
window.GeometryAlgolia.autocompleteDebounceMs = window.GeometryAlgolia.autocompleteDebounceMs || 500;
window.GeometryAlgolia.instantSearchDebounceMs =
  window.GeometryAlgolia.instantSearchDebounceMs || window.GeometryAlgolia.autocompleteDebounceMs;
window.GeometryAlgolia.autocompleteStallThresholdMs =
  window.GeometryAlgolia.autocompleteDebounceMs + 300;

window.GeometryAlgolia.getNormalizedQuery = function (query) {
  return String(query || "").trim();
};

window.GeometryAlgolia.isSearchQueryReady = function (query) {
  return window.GeometryAlgolia.getNormalizedQuery(query).length >= window.GeometryAlgolia.minSearchQueryLength;
};

window.GeometryAlgolia.isInstantSearchTemplate = function () {
  return Boolean(document.body && document.body.classList.contains("template-search"));
};

window.GeometryAlgolia.normalizeFacetKey = function (value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
};

window.GeometryAlgolia.colorFacetSwatches = {
  white: "#FFFFFF",
  black: "#000000",
  black_and_white: "linear-gradient(45deg, white 0%, white 50%, black 50%, black 100%)",
  blue: "#4A90D9",
  riviera: "#7FB7D8",
  brown: "#8B4513",
  green: "#4A7C59",
  orange: "#FFA500",
  pink: "#E8A0B0",
  peach: "#F4C6B7",
  purple: "#7B5EA7",
  red: "#CC3333",
  yellow: "#F5C518",
  gray: "#808080",
  grey: "#808080",
  stone: "#D8D2C4",
  multicolor: "linear-gradient(90deg, red, orange, yellow, green, blue, purple)",
  mulitcolor: "linear-gradient(90deg, red, orange, yellow, green, blue, purple)",
  beige: "#F5F0E8",
  natural: "#C09B52",
  gold: "#C09B52",
  dark_brown: "#4D433D",
  clay_red: "#7C220F",
  off_white: "#E6D7C3",
  cabernet: "#683D44",
  mossfield: "#746F34",
  oat: "#E2CFB3",
  oxford: "#26354B",
  rustwood: "#B25A2F",
  saddle: "#997054",
  saffron: "#C89939",
};

window.GeometryAlgolia.getColorFacetSwatch = function (value) {
  return window.GeometryAlgolia.colorFacetSwatches[window.GeometryAlgolia.normalizeFacetKey(value)] || "";
};

window.GeometryAlgolia.isColorFacet = function (facet) {
  var name = window.GeometryAlgolia.normalizeFacetKey(facet && facet.name);
  var title = window.GeometryAlgolia.normalizeFacetKey(facet && facet.title);

  return name.indexOf("color") !== -1 || title.indexOf("color") !== -1;
};

window.GeometryAlgolia.getFacetVisibilityClassNames = function (facet) {
  var name = window.GeometryAlgolia.normalizeFacetKey(facet && facet.name);
  var title = window.GeometryAlgolia.normalizeFacetKey(facet && facet.title);
  var classNames = [];

  if (facet && facet.type === "slider") {
    classNames.push("geometry-ais-facet--price-slider");
  }

  if (name === "price" || name === "price_range" || title === "price" || title === "price_range") {
    classNames.push("geometry-ais-facet--price");
  }

  if (name === "vendor" || name === "product_vendor" || title === "vendor") {
    classNames.push("geometry-ais-facet--vendor");
  }

  if (name === "tags" || title === "tags") {
    classNames.push("geometry-ais-facet--tags");
  }

  if (window.GeometryAlgolia.isColorFacet(facet)) {
    classNames.push("geometry-ais-facet--color");
  }

  return classNames;
};

window.GeometryAlgolia.addFacetRootClassNames = function (params, classNames) {
  if (!Array.isArray(classNames) || classNames.length === 0) return params;

  var nextParams = Object.assign({}, params);
  var cssClasses = Object.assign({}, nextParams.cssClasses);
  var rootClasses = [];

  if (Array.isArray(cssClasses.root)) {
    rootClasses = cssClasses.root.slice();
  } else if (cssClasses.root) {
    rootClasses = String(cssClasses.root).split(/\s+/);
  }

  classNames.forEach(function (className) {
    if (rootClasses.indexOf(className) === -1) rootClasses.push(className);
  });

  cssClasses.root = rootClasses.join(" ").trim();
  nextParams.cssClasses = cssClasses;

  return nextParams;
};

window.GeometryAlgolia.getAlgoliaRequestQuery = function (request) {
  var params = request && request.params;

  if (params && typeof params.query === "string") return params.query;
  if (request && typeof request.query === "string") return request.query;

  if (typeof params === "string" && typeof URLSearchParams !== "undefined") {
    try {
      return new URLSearchParams(params).get("query") || "";
    } catch (_error) {}
  }

  return "";
};

window.GeometryAlgolia.serializeAlgoliaRequestParams = function (params) {
  if (!params) return "";
  if (typeof params === "string") return params;

  if (typeof URLSearchParams !== "undefined") {
    try {
      return new URLSearchParams(params).toString();
    } catch (_error) {}
  }

  return "";
};

window.GeometryAlgolia.shouldShortCircuitAlgoliaRequests = function (requests) {
  if (!Array.isArray(requests) || requests.length === 0) return false;

  return requests.every(function (request) {
    return !window.GeometryAlgolia.isSearchQueryReady(window.GeometryAlgolia.getAlgoliaRequestQuery(request));
  });
};

window.GeometryAlgolia.getEmptyAlgoliaSearchResponse = function (requests) {
  return Promise.resolve({
    results: requests.map(function (request) {
      var params = request && request.params;

      return {
        hits: [],
        nbHits: 0,
        nbPages: 0,
        page: 0,
        processingTimeMS: 0,
        hitsPerPage: 0,
        exhaustiveNbHits: false,
        query: window.GeometryAlgolia.getAlgoliaRequestQuery(request),
        params: window.GeometryAlgolia.serializeAlgoliaRequestParams(params),
      };
    }),
  });
};

window.GeometryAlgolia.debouncePromise = function (fn, wait) {
  var timer;

  return function debounced() {
    var context = this;
    var args = arguments;

    if (timer) window.clearTimeout(timer);

    return new Promise(function (resolve, reject) {
      timer = window.setTimeout(function () {
        Promise.resolve(fn.apply(context, args)).then(resolve).catch(reject);
      }, wait);
    });
  };
};

window.GeometryAlgolia.wrapAutocompleteSearchClient = function (searchClient) {
  if (!searchClient || typeof searchClient.search !== "function") return searchClient;
  if (searchClient.__geometryAutocompleteSearchClient) return searchClient;

  if (!window.GeometryAlgolia.autocompleteSearchClientCache && typeof WeakMap !== "undefined") {
    window.GeometryAlgolia.autocompleteSearchClientCache = new WeakMap();
  }

  if (
    window.GeometryAlgolia.autocompleteSearchClientCache &&
    window.GeometryAlgolia.autocompleteSearchClientCache.has(searchClient)
  ) {
    return window.GeometryAlgolia.autocompleteSearchClientCache.get(searchClient);
  }

  var originalSearch = searchClient.search.bind(searchClient);
  var debouncedSearch = window.GeometryAlgolia.debouncePromise(
    originalSearch,
    window.GeometryAlgolia.autocompleteDebounceMs,
  );
  var wrappedClient = Object.assign({}, searchClient, {
    __geometryAutocompleteSearchClient: true,
    search: function (requests) {
      if (window.GeometryAlgolia.shouldShortCircuitAlgoliaRequests(requests)) {
        return window.GeometryAlgolia.getEmptyAlgoliaSearchResponse(requests);
      }

      return debouncedSearch(requests);
    },
  });

  if (window.GeometryAlgolia.autocompleteSearchClientCache) {
    window.GeometryAlgolia.autocompleteSearchClientCache.set(searchClient, wrappedClient);
  }

  return wrappedClient;
};

window.GeometryAlgolia.installInstantSearchSearchBoxDebounce = function () {
  var widgets = window.algoliaShopify && window.algoliaShopify.externals && window.algoliaShopify.externals.widgets;
  var searchBox = widgets && widgets.searchBox;

  if (typeof searchBox !== "function" || searchBox.__geometryInstantSearchDebounce) return;

  var wrappedSearchBox = function (options) {
    var nextOptions = Object.assign({}, options);
    var originalQueryHook = nextOptions.queryHook;
    var timer;

    nextOptions.queryHook = function (query, refine) {
      if (timer) window.clearTimeout(timer);

      timer = window.setTimeout(function () {
        if (typeof originalQueryHook === "function") {
          originalQueryHook(query, refine);
          return;
        }

        refine(query);
      }, window.GeometryAlgolia.instantSearchDebounceMs);
    };

    return searchBox(nextOptions);
  };

  wrappedSearchBox.__geometryInstantSearchDebounce = true;
  widgets.searchBox = wrappedSearchBox;
};

window.GeometryAlgolia.getImage = function (item, size) {
  if (!item) return null;

  if (window.algoliaShopify && window.algoliaShopify.helpers && window.algoliaShopify.helpers.renderImage) {
    try {
      var renderedImage = window.algoliaShopify.helpers.renderImage(item, size);
      if (renderedImage && renderedImage.src) return renderedImage;
    } catch (_error) {}
  }

  if (typeof item.image === "string" && item.image) {
    return {
      src: item.image,
      srcset: "",
      sizes: "",
    };
  }

  if (item.image && typeof item.image === "object") {
    var src = item.image.src || item.image.url || item.image.original || item.image.medium || item.image.large;
    if (src) {
      return {
        src: src,
        srcset: item.image.srcset || "",
        sizes: "",
      };
    }
  }

  return null;
};

window.GeometryAlgolia.getImageSource = function (image) {
  if (!image) return "";
  if (typeof image === "string") return image;
  if (image.preview_image && image.preview_image.src) return image.preview_image.src;
  if (image.preview && image.preview.src) return image.preview.src;
  return image.src || image.url || image.original || image.medium || image.large || "";
};

window.GeometryAlgolia.getResizedImageSource = function (src, size) {
  if (!src) return "";

  var normalizedSrc = src.indexOf("//") === 0 ? "https:" + src : src;

  try {
    var url = new URL(normalizedSrc, window.location.origin);

    if (size && /(^|\.)shopifycdn\.net$|(^|\.)shopify\.com$/.test(url.hostname)) {
      url.searchParams.set("width", size);
    }

    return url.toString();
  } catch (_error) {
    return normalizedSrc;
  }
};

window.GeometryAlgolia.getImageFromSource = function (src, size, alt) {
  if (!src) return null;

  return {
    src: window.GeometryAlgolia.getResizedImageSource(src, size),
    srcset: [1, 2, 3]
      .map(function (density) {
        return window.GeometryAlgolia.getResizedImageSource(src, size * density) + " " + density + "x";
      })
      .join(", "),
    sizes: "(max-width: " + size + "px) 100vw, " + size + "px",
    alt: alt || "",
  };
};

window.GeometryAlgolia.getComparableImageSource = function (src) {
  if (!src) return "";

  try {
    var url = new URL(src.indexOf("//") === 0 ? "https:" + src : src, window.location.origin);
    url.search = "";
    url.hash = "";
    url.pathname = url.pathname.replace(
      /_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x|x\d+)(?=\.[^/.]+$)/,
      "",
    );
    return url.hostname + url.pathname;
  } catch (_error) {
    return src;
  }
};

window.GeometryAlgolia.isSameImageSource = function (left, right) {
  return (
    window.GeometryAlgolia.getComparableImageSource(left) === window.GeometryAlgolia.getComparableImageSource(right)
  );
};

window.GeometryAlgolia.getSecondaryImage = function (item, size, primaryImage) {
  if (!item) return null;

  var candidates = [];
  var arrayKeys = ["media", "images", "product_images", "product_media", "additional_images"];
  var singleKeys = [
    "secondary_image",
    "second_image",
    "alternate_image",
    "hover_image",
    "image2",
    "image_2",
    "product_image_2",
  ];
  var primarySrc = primaryImage && primaryImage.src;

  arrayKeys.forEach(function (key) {
    if (Array.isArray(item[key])) candidates = candidates.concat(item[key]);
  });

  singleKeys.forEach(function (key) {
    if (item[key]) candidates.push(item[key]);
  });

  for (var index = 0; index < candidates.length; index += 1) {
    var candidate = candidates[index];
    var src = window.GeometryAlgolia.getImageSource(candidate);

    if (!src || window.GeometryAlgolia.isSameImageSource(src, primarySrc)) continue;

    return window.GeometryAlgolia.getImageFromSource(src, size, candidate.alt || item.title);
  }

  return null;
};

window.GeometryAlgolia.getVariantId = function (item) {
  if (!item) return "";
  if (item.variant_id) return item.variant_id;
  if (item.variantId) return item.variantId;
  if (item.variant && item.variant.id) return item.variant.id;
  if (Array.isArray(item.variants) && item.variants[0] && item.variants[0].id) return item.variants[0].id;
  return item.objectID || "";
};

window.GeometryAlgolia.getProductUrl = function (item) {
  if (!item) return "#";

  if (
    window.algoliaShopify &&
    window.algoliaShopify.helpers &&
    typeof window.algoliaShopify.helpers.instantsearchLink === "function"
  ) {
    return window.algoliaShopify.helpers.instantsearchLink(item);
  }

  if (item.handle) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    return root + "products/" + item.handle;
  }

  return item.url || "#";
};

window.GeometryAlgolia.displayPriceNoDecimals = function (item, distinct) {
  if (!window.algoliaShopify || !window.algoliaShopify.helpers) return "";

  var price = window.algoliaShopify.helpers.displayPrice(item, distinct);
  if (price === null || typeof price === "undefined") return "";

  return String(price).replace(/\.\d{2}(?=\D|$)/g, "");
};

window.GeometryAlgolia.categoryLinks = [
  { label: "Kitchen", path: "pages/kitchen", image: "Geometry9.11.25_0091.jpg" },
  { label: "Table", path: "pages/table", image: "Geometry6.11.25_0400_1_result.webp" },
  { label: "Bath", path: "pages/bath", image: "Geometry9.2.25_0041_result.webp" },
  { label: "Blankets", path: "pages/blankets", image: "0039__0000s_0006_MB-MF-theo-2.jpg" },
  { label: "Active", path: "pages/active", image: "Copy_of_GrantPuckett_GeometryFitness_00325.jpg" },
  { label: "Beach", path: "pages/beach", image: "Beach-Game-Edit-111.jpg" },
  { label: "Pet", path: "pages/pet", image: "GEO_WelcomeSeries-6_03-Alt1.png" },
  { label: "Gift Cards", path: "pages/gift-cards", image: "Geometry-SpringEaster-GrantPuckett-0397-Retouch.jpg" },
];

window.GeometryAlgolia.getThemeRoute = function (path) {
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  return root + path.replace(/^\//, "");
};

window.GeometryAlgolia.getShopFileImage = function (filename, width) {
  if (!filename) return "";
  return "/cdn/shop/files/" + encodeURIComponent(filename) + "?width=" + (width || 160);
};

window.GeometryAlgolia.getInfiniteHitsWidget = function () {
  if (window.instantsearch && window.instantsearch.widgets && window.instantsearch.widgets.infiniteHits) {
    return window.instantsearch.widgets.infiniteHits;
  }

  if (
    window.algoliaShopify &&
    window.algoliaShopify.externals &&
    window.algoliaShopify.externals.widgets &&
    window.algoliaShopify.externals.widgets.infiniteHits
  ) {
    return window.algoliaShopify.externals.widgets.infiniteHits;
  }

  return null;
};

window.GeometryAlgolia.trackInstantSearchProduct = function (item) {
  if (
    window.algoliaShopify &&
    window.algoliaShopify.helpers &&
    typeof window.algoliaShopify.helpers.handleItemClick === "function"
  ) {
    window.algoliaShopify.helpers.handleItemClick(item);
  }
};

window.GeometryAlgolia.autocompleteProductsStep = 12;
window.GeometryAlgolia.autocompleteProductsLimit = window.GeometryAlgolia.autocompleteProductsStep;
window.GeometryAlgolia.autocompleteProductsCount = null;

window.GeometryAlgolia.resetAutocompleteProductsLimit = function () {
  window.GeometryAlgolia.autocompleteProductsLimit = window.GeometryAlgolia.autocompleteProductsStep;
  window.GeometryAlgolia.autocompleteProductsCount = null;
  window.GeometryAlgolia.autocompleteLoadingMore = false;
};

window.GeometryAlgolia.getAutocompletePanelScroller = function () {
  var panel = document.querySelector(".aa-Panel");
  if (!panel) return null;

  var candidates = [
    panel.querySelector(".aa-Panel--scrollable"),
    panel.querySelector(".aa-PanelLayout"),
    panel,
  ];

  for (var index = 0; index < candidates.length; index += 1) {
    var candidate = candidates[index];
    if (candidate && candidate.scrollHeight > candidate.clientHeight) return candidate;
  }

  return panel;
};

window.GeometryAlgolia.restoreAutocompleteScrollPosition = function () {
  var scrollTop = window.GeometryAlgolia.autocompleteScrollTop;
  if (typeof scrollTop !== "number") return;

  var scroller = window.GeometryAlgolia.getAutocompletePanelScroller();
  if (scroller) scroller.scrollTop = scrollTop;
};

window.GeometryAlgolia.findAutocompleteController = function () {
  var roots = [];

  if (window.algoliaShopify) {
    roots.push(window.algoliaShopify);
    if (window.algoliaShopify.config) roots.push(window.algoliaShopify.config);
  }

  var seen = [];

  var findController = function (value, depth) {
    if (!value || typeof value !== "object" || depth > 3 || seen.indexOf(value) !== -1) return null;
    seen.push(value);

    if (typeof value.refresh === "function" && typeof value.update === "function") return value;

    var keys = Object.keys(value);
    for (var index = 0; index < keys.length; index += 1) {
      var result = findController(value[keys[index]], depth + 1);
      if (result) return result;
    }

    return null;
  };

  for (var index = 0; index < roots.length; index += 1) {
    var controller = findController(roots[index], 0);
    if (controller) return controller;
  }

  return null;
};

window.GeometryAlgolia.refreshAutocompleteProducts = function () {
  var controller = window.GeometryAlgolia.autocompleteController || window.GeometryAlgolia.findAutocompleteController();
  var refresh = window.GeometryAlgolia.autocompleteRefresh || (controller && controller.refresh);

  if (controller) {
    window.GeometryAlgolia.autocompleteController = controller;
  }

  if (typeof refresh === "function") {
    refresh.call(controller || window.algoliaShopify);
    window.setTimeout(window.GeometryAlgolia.restoreAutocompleteScrollPosition, 0);
    window.setTimeout(window.GeometryAlgolia.restoreAutocompleteScrollPosition, 120);
    return;
  }

  var input = document.querySelector(".aa-Input");
  if (input) {
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }
};

window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded = function () {
  var scroller = window.GeometryAlgolia.getAutocompletePanelScroller();
  if (!scroller || window.GeometryAlgolia.autocompleteLoadingMore) return;

  var remainingScroll = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
  if (remainingScroll > 700) return;

  var currentLimit = window.GeometryAlgolia.autocompleteProductsLimit;
  var totalProducts = window.GeometryAlgolia.autocompleteProductsCount;
  var nextLimit = currentLimit + window.GeometryAlgolia.autocompleteProductsStep;

  if (typeof totalProducts === "number") {
    nextLimit = Math.min(nextLimit, totalProducts);
  }

  if (nextLimit <= currentLimit) return;

  window.GeometryAlgolia.autocompleteLoadingMore = true;
  window.GeometryAlgolia.autocompleteScrollTop = scroller.scrollTop;
  window.GeometryAlgolia.autocompleteProductsLimit = nextLimit;
  window.GeometryAlgolia.refreshAutocompleteProducts();

  window.setTimeout(function () {
    window.GeometryAlgolia.autocompleteLoadingMore = false;
    window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded();
  }, 600);
};

window.GeometryAlgolia.watchAutocompletePanelScroll = function () {
  if (window.GeometryAlgolia.autocompletePanelScrollWatcherStarted || !document.body) return;

  window.GeometryAlgolia.autocompletePanelScrollWatcherStarted = true;

  document.addEventListener(
    "scroll",
    function (event) {
      var panel = document.querySelector(".aa-Panel");
      if (!panel || !event.target || !panel.contains(event.target)) return;

      window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded();
    },
    true,
  );

  var observer = new MutationObserver(function () {
    var scroller = window.GeometryAlgolia.getAutocompletePanelScroller();

    if (scroller && scroller.dataset.geometryAutocompleteScrollObserved !== "true") {
      scroller.dataset.geometryAutocompleteScrollObserved = "true";
      scroller.addEventListener("scroll", window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded);
      scroller.addEventListener("wheel", window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded, { passive: true });
      scroller.addEventListener("touchmove", window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded, {
        passive: true,
      });
    }

    window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

window.GeometryAlgolia.renderInstantSearchProduct = function (item, html, components, trackSearchAttribution) {
  var image = window.GeometryAlgolia.getImage(item, 540);
  var secondaryImage = window.GeometryAlgolia.getSecondaryImage(item, 540, image);
  var distinct = Boolean(item && item._distinct);
  var productUrl = window.GeometryAlgolia.getProductUrl(item);
  var productTitle = [item.title, item.product_type].filter(Boolean).join(" ");
  var variantId = window.GeometryAlgolia.getVariantId(item);
  var quickAddAvailable = item && (item.available === false || item.inventory_available === false) ? false : true;
  var productUid = String(variantId || item.id || item.handle || item.productPosition || "product").replace(
    /[^a-z0-9_-]/gi,
    "-",
  );
  var titleId = "geometry-ais-product-title-" + productUid;
  var quickAddId = "geometry-ais-quick-add-" + productUid;
  var trackProductClick = function () {
    if (typeof trackSearchAttribution === "function") {
      trackSearchAttribution(item);
    } else {
      window.GeometryAlgolia.trackInstantSearchProduct(item);
    }
  };

  return html`
    <div
      class="geometry-ais-product collection-product-card quickview--hover"
      data-algolia-index="${item.index || ""}"
      data-algolia-position="${item.productPosition || ""}"
      data-algolia-queryid="${item.queryID || ""}"
      data-algolia-objectid="${item.objectID || ""}"
      data-handle="${item.handle || ""}"
      data-variant-id="${variantId || ""}"
      data-distinct="${item._distinct || ""}"
      data-product-id="${item.id || ""}"
      data-product="${item.handle || ""}"
    >
      <div class="card-wrapper js-color-swatches-wrapper" data-product="${item.handle || ""}">
        <span class="visually-hidden">${productTitle}</span>
        <div class="card card--product" tabindex="-1">
          <div class="card__inner full-unstyled-link">
            <div class="geometry-ais-product__media media media--transparent media--hover-effect">
              ${
                image
                  ? html`
                      <img
                        class="motion-reduce media--first"
                        src="${image.src}"
                        srcset="${image.srcset}"
                        sizes="${image.sizes}"
                        alt="${item.title || "Product image"}"
                        loading="lazy"
                      />
                      ${
                        secondaryImage &&
                        html`
                          <img
                            class="motion-reduce media--second"
                            src="${secondaryImage.src}"
                            srcset="${secondaryImage.srcset}"
                            sizes="${secondaryImage.sizes}"
                            alt="${secondaryImage.alt || item.title || "Product image"}"
                            loading="lazy"
                          />
                        `
                      }
                    `
                  : html`<span>${(item.title || "").slice(0, 1)}</span>`
              }
            </div>
            ${
              variantId &&
              html`
                <product-form class="card__add-to-cart card__button geometry-ais-product__quick-add" data-hide-errors="true">
                  <form method="post" action="/cart/add" class="form" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="id" value="${variantId}" disabled />
                    <input type="hidden" name="quantity" value="1" />
                    ${item.product_type && html`<input type="hidden" name="properties[Product type]" value="${item.product_type}" />`}
                    <button
                      id="${quickAddId}-submit"
                      type="submit"
                      class="card__link button button--primary mobile-button--primary card__link--hover card__link--show card-focused"
                      name="add"
                      aria-label="Add to Cart"
                      aria-haspopup="dialog"
                      aria-labelledby="${quickAddId}-submit ${titleId}"
                      aria-live="polite"
                      aria-disabled="${quickAddAvailable ? "false" : "true"}"
                      data-sold-out-message="true"
                      ${!quickAddAvailable && html`disabled`}
                    >
                      <span class="card__quickview-text ${quickAddAvailable ? "" : "hidden"}">Add to Cart</span>
                      <span class="sold-out-message ${quickAddAvailable ? "hidden" : ""}">Sold Out</span>
                      <div class="loading-overlay__spinner hidden">
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="spinner"
                          viewBox="0 0 66 66"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </button>
                  </form>
                </product-form>
              `
            }
          </div>
        </div>
        <div class="geometry-ais-product__body card-information">
          <div class="card-information__wrapper">
            <div class="card-information__group">
              <h3 id="${titleId}" class="geometry-ais-product__title card__title h5">
                <a class="full-unstyled-link" href="${productUrl}" title="${productTitle}" onClick="${trackProductClick}">
                  ${components.Highlight({ hit: item, attribute: "title" })}
                  ${
                    item.product_type &&
                    html`
                      ${" "}
                      <span class="geometry-ais-product__title-type">
                        ${components.Highlight({ hit: item, attribute: "product_type" })}
                      </span>
                    `
                  }
                  ${
                    window.algoliaShopify &&
                    window.algoliaShopify.helpers &&
                    window.algoliaShopify.helpers.variantTitleAddition(item, distinct)
                  }
                </a>
              </h3>
              <div class="card-information__price-rating-row">
                <div class="geometry-ais-product__price price">
                  ${window.GeometryAlgolia.displayPriceNoDecimals(item, distinct)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          href="${productUrl}"
          class="link link--overlay card-wrapper__link--overlay js-color-swatches-link"
          aria-label="${productTitle}"
          onClick="${trackProductClick}"
        ></a>
      </div>
    </div>
  `;
};

window.GeometryAlgolia.productJsonCache = window.GeometryAlgolia.productJsonCache || {};

window.GeometryAlgolia.loadProductJson = function (handle) {
  if (!handle || !window.fetch) return Promise.resolve(null);

  if (window.GeometryAlgolia.productJsonCache[handle]) {
    return window.GeometryAlgolia.productJsonCache[handle];
  }

  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  var url = root + "products/" + encodeURIComponent(handle) + ".js";

  window.GeometryAlgolia.productJsonCache[handle] = fetch(url, { credentials: "same-origin" })
    .then(function (response) {
      if (!response.ok) throw new Error("Unable to load product JSON");
      return response.json();
    })
    .catch(function () {
      return null;
    });

  return window.GeometryAlgolia.productJsonCache[handle];
};

window.GeometryAlgolia.canDirectQuickAddProduct = function (product) {
  if (!product) return false;

  var variants = Array.isArray(product.variants) ? product.variants : [];
  if (variants.length <= 1) return true;

  var optionNames = (Array.isArray(product.options) ? product.options : [])
    .map(function (option) {
      if (typeof option === "string") return option;
      return option && option.name;
    })
    .filter(Boolean);

  return optionNames.length === 1 && window.GeometryAlgolia.normalizeFacetKey(optionNames[0]) === "color";
};

window.GeometryAlgolia.updateQuickAddAvailability = function (card, product) {
  if (!card || !product) return;

  var quickAdd = card.querySelector(".geometry-ais-product__quick-add, .geometry-aa-product__quick-add");
  var input = card.querySelector('.card__add-to-cart input[name="id"]');
  var button = card.querySelector('.card__add-to-cart button[name="add"]');

  if (!window.GeometryAlgolia.canDirectQuickAddProduct(product)) {
    if (quickAdd) quickAdd.remove();
    return;
  }

  if (!input || !button) return;

  var variantId = card.dataset.variantId;
  var variants = Array.isArray(product.variants) ? product.variants : [];
  var firstAvailableVariant = variants.find(function (candidate) {
    return candidate && candidate.available !== false;
  });
  var variant =
    variants.find(function (candidate) {
      return String(candidate.id) === String(variantId);
    }) ||
    firstAvailableVariant ||
    variants[0];

  if (!variant) return;

  input.value = variant.id;
  input.disabled = false;
  card.dataset.variantId = variant.id;

  if (variant.available === false) {
    button.setAttribute("aria-disabled", "true");
    button.setAttribute("disabled", "disabled");
    button.querySelector(".card__quickview-text")?.classList.add("hidden");
    button.querySelector(".sold-out-message")?.classList.remove("hidden");
  } else {
    button.setAttribute("aria-disabled", "false");
    button.removeAttribute("disabled");
    button.querySelector(".card__quickview-text")?.classList.remove("hidden");
    button.querySelector(".sold-out-message")?.classList.add("hidden");
  }
};

window.GeometryAlgolia.getProductCardHandle = function (card) {
  return (card && (card.dataset.handle || card.dataset.product)) || "";
};

window.GeometryAlgolia.prepareProductCardEnhancement = function (card, handle) {
  if (!card || !handle) return false;

  if (
    card.dataset.geometryProductEnhancedFor &&
    card.dataset.geometryProductEnhancedFor !== handle
  ) {
    card
      .querySelectorAll('.media--second[data-geometry-product-json-image="true"]')
      .forEach(function (image) {
        image.remove();
      });
  }

  if (card.dataset.geometryProductEnhancedFor === handle) return false;

  card.dataset.geometryProductEnhanced = "true";
  card.dataset.geometryProductEnhancedFor = handle;

  return true;
};

window.GeometryAlgolia.addSecondaryProductImage = function (card, product) {
  if (!card || !product) return;

  var media = card.querySelector(".geometry-ais-product__media, .geometry-aa-product__picture");
  var primaryImage = media && media.querySelector("img");
  if (!media || !primaryImage || media.querySelector(".media--second")) return;

  var secondMedia = Array.isArray(product.media) ? product.media[1] : null;
  var secondImageSource = window.GeometryAlgolia.getImageSource(secondMedia) || (product.images && product.images[1]);

  if (!secondImageSource || window.GeometryAlgolia.isSameImageSource(secondImageSource, primaryImage.src)) return;

  var secondImage = window.GeometryAlgolia.getImageFromSource(
    secondImageSource,
    540,
    (secondMedia && secondMedia.alt) || product.title || primaryImage.alt,
  );
  var imageElement = document.createElement("img");

  imageElement.className = "motion-reduce media--second";
  imageElement.src = secondImage.src;
  imageElement.srcset = secondImage.srcset;
  imageElement.sizes = secondImage.sizes;
  imageElement.alt = secondImage.alt || "";
  imageElement.loading = "lazy";
  imageElement.dataset.geometryProductJsonImage = "true";
  media.appendChild(imageElement);
};

window.GeometryAlgolia.enhanceInstantSearchProductCards = function () {
  if (!window.GeometryAlgolia.isInstantSearchTemplate()) return;

  document.querySelectorAll("#MainContent .shopify-app-block .geometry-ais-product").forEach(function (card) {
    var media = card.querySelector(".geometry-ais-product__media");
    var primaryImage = media && media.querySelector("img:first-child");

    if (media) {
      media.classList.add("media", "media--transparent", "media--hover-effect");
    }

    if (primaryImage) {
      primaryImage.classList.add("motion-reduce", "media--first");
    }

    var handle = window.GeometryAlgolia.getProductCardHandle(card);
    if (!handle) return;
    if (!window.GeometryAlgolia.prepareProductCardEnhancement(card, handle)) return;

    window.GeometryAlgolia.loadProductJson(handle).then(function (product) {
      if (!product || !card.isConnected) return;
      if (window.GeometryAlgolia.getProductCardHandle(card) !== handle) return;

      window.GeometryAlgolia.addSecondaryProductImage(card, product);
      window.GeometryAlgolia.updateQuickAddAvailability(card, product);
    });
  });
};

window.GeometryAlgolia.enhanceInstantSearchProductCardsDeferred = function () {
  [0, 160, 500, 1200].forEach(function (delay) {
    window.setTimeout(window.GeometryAlgolia.enhanceInstantSearchProductCards, delay);
  });
};

window.GeometryAlgolia.enhanceAutocompleteProductCards = function () {
  document.querySelectorAll(".aa-Panel .geometry-aa-product.collection-product-card").forEach(function (card) {
    var media = card.querySelector(".geometry-aa-product__picture");
    var primaryImage = media && media.querySelector("img:first-child");

    if (media) {
      media.classList.add("media", "media--transparent", "media--hover-effect");
    }

    if (primaryImage) {
      primaryImage.classList.add("motion-reduce", "media--first");
    }

    var handle = window.GeometryAlgolia.getProductCardHandle(card);
    if (!handle) return;
    if (!window.GeometryAlgolia.prepareProductCardEnhancement(card, handle)) return;

    window.GeometryAlgolia.loadProductJson(handle).then(function (product) {
      if (!product || !card.isConnected) return;
      if (window.GeometryAlgolia.getProductCardHandle(card) !== handle) return;

      window.GeometryAlgolia.addSecondaryProductImage(card, product);
      window.GeometryAlgolia.updateQuickAddAvailability(card, product);
    });
  });
};

window.GeometryAlgolia.enhanceAutocompleteProductCardsDeferred = function () {
  [0, 120, 360, 900].forEach(function (delay) {
    window.setTimeout(window.GeometryAlgolia.enhanceAutocompleteProductCards, delay);
  });
};

window.GeometryAlgolia.setupMobileFacetToggle = function () {
  var page = document.querySelector("#MainContent .shopify-app-block .ais-page");
  var button = page && page.querySelector(".ais-facets-button");
  var facets = page && page.querySelector(".ais-facets");

  if (!page || !button || !facets) return;

  var isCurrentButton = function () {
    return button.isConnected && button === page.querySelector(".ais-facets-button");
  };

  var setOpen = function (isOpen) {
    if (!isCurrentButton()) return;

    var currentFacets = page.querySelector(".ais-facets");

    if (!currentFacets) return;

    page.classList.toggle("geometry-ais-facets-open", isOpen);
    currentFacets.classList.toggle("geometry-ais-facets-open", isOpen);
    button.classList.toggle("geometry-ais-facets-button-open", isOpen);
    button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    button.textContent = isOpen ? "Hide filters" : "Show filters";
  };

  button.setAttribute("role", "button");
  button.setAttribute("tabindex", "0");
  button.setAttribute("aria-controls", "geometry-ais-mobile-facets");
  button.setAttribute("aria-expanded", page.classList.contains("geometry-ais-facets-open") ? "true" : "false");
  facets.id = facets.id || "geometry-ais-mobile-facets";

  if (button.dataset.geometryFacetToggleReady === "true") return;
  button.dataset.geometryFacetToggleReady = "true";

  button.addEventListener("click", function () {
    if (!isCurrentButton()) return;

    setOpen(!page.classList.contains("geometry-ais-facets-open"));
  });

  button.addEventListener("keydown", function (event) {
    if (!isCurrentButton()) return;
    if (event.key !== "Enter" && event.key !== " ") return;

    event.preventDefault();
    setOpen(!page.classList.contains("geometry-ais-facets-open"));
  });
};

window.GeometryAlgolia.getFacetLabelText = function (label) {
  if (!label) return "";

  var clone = label.cloneNode(true);

  clone
    .querySelectorAll(
      'input, .geometry-ais-color-swatch, .ais-RefinementList-count, .ais-Menu-count, .ais-HierarchicalMenu-count, .ais-facet--count',
    )
    .forEach(function (node) {
      node.remove();
    });

  return clone.textContent.replace(/\s+/g, " ").trim().replace(/\s+\(?[\d,]+\)?$/, "");
};

window.GeometryAlgolia.isColorFacetRoot = function (root) {
  if (!root) return false;

  if (root.classList && root.classList.contains("geometry-ais-facet--color")) return true;

  var header = root.querySelector(".ais-Panel-header, .ais-facet--header, .ais-facet--title");
  var headerText = window.GeometryAlgolia.normalizeFacetKey(header && header.textContent);
  var className = window.GeometryAlgolia.normalizeFacetKey(root.className);

  return headerText.indexOf("color") !== -1 || className.indexOf("color") !== -1;
};

window.GeometryAlgolia.decorateColorFacets = function () {
  var roots = document.querySelectorAll(
    "#MainContent .shopify-app-block .ais-facets .geometry-ais-facet--color, #MainContent .shopify-app-block .ais-facets .ais-Panel, #MainContent .shopify-app-block .ais-facets .ais-facet-dropdown-wrapper, #MainContent .shopify-app-block .ais-facets .ais-facet",
  );

  roots.forEach(function (root) {
    if (!window.GeometryAlgolia.isColorFacetRoot(root)) return;

    root.classList.add("geometry-ais-facet--color");

    root
      .querySelectorAll(".ais-RefinementList-label, .ais-Menu-link, .ais-HierarchicalMenu-link, .ais-facet--label")
      .forEach(function (label) {
        var value = window.GeometryAlgolia.getFacetLabelText(label);
        var swatchValue = window.GeometryAlgolia.getColorFacetSwatch(value);

        if (!swatchValue) return;
        if (label.dataset.geometryColorSwatchValue === value) return;

        label.querySelectorAll(".geometry-ais-color-swatch").forEach(function (node) {
          node.remove();
        });

        var swatch = document.createElement("span");
        var normalizedValue = window.GeometryAlgolia.normalizeFacetKey(value);

        swatch.className = "geometry-ais-color-swatch";
        swatch.style.background = swatchValue;
        swatch.setAttribute("aria-hidden", "true");

        if (normalizedValue === "white" || normalizedValue === "off_white") {
          swatch.classList.add("geometry-ais-color-swatch--light");
        }

        var input = label.querySelector('input[type="checkbox"], input[type="radio"]');

        if (input && input.nextSibling) {
          label.insertBefore(swatch, input.nextSibling);
        } else {
          label.insertBefore(swatch, label.firstChild);
        }

        label.dataset.geometryColorSwatchValue = value;
      });
  });
};

window.GeometryAlgolia.getScrollParent = function (element) {
  var parent = element && element.parentElement;

  while (parent && parent !== document.body) {
    var styles = window.getComputedStyle(parent);
    var overflowY = styles.overflowY || styles.overflow;

    if (/(auto|scroll|overlay)/.test(overflowY) && parent.scrollHeight > parent.clientHeight) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return window;
};

window.GeometryAlgolia.canLoadMoreInstantSearchHits = function (button) {
  return (
    button &&
    !button.disabled &&
    !button.classList.contains("ais-InfiniteHits-loadMore--disabled") &&
    button.dataset.geometryLoading !== "true"
  );
};

window.GeometryAlgolia.loadMoreInstantSearchHits = function (button) {
  if (!window.GeometryAlgolia.canLoadMoreInstantSearchHits(button)) return;

  button.dataset.geometryLoading = "true";
  button.click();

  window.setTimeout(function () {
    button.dataset.geometryLoading = "false";
    window.GeometryAlgolia.setupInstantSearchInfiniteObserver();
  }, 700);
};

window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded = function () {
  var button = document.querySelector(".ais-InfiniteHits-loadMore");
  if (!window.GeometryAlgolia.canLoadMoreInstantSearchHits(button)) return;

  var threshold = 900;
  var scrollParent = window.GeometryAlgolia.getScrollParent(button);

  if (scrollParent === window) {
    if (button.getBoundingClientRect().top - window.innerHeight <= threshold) {
      window.GeometryAlgolia.loadMoreInstantSearchHits(button);
    }

    return;
  }

  if (scrollParent.scrollHeight - scrollParent.scrollTop - scrollParent.clientHeight <= threshold) {
    window.GeometryAlgolia.loadMoreInstantSearchHits(button);
  }
};

window.GeometryAlgolia.setupInstantSearchInfiniteObserver = function () {
  var button = document.querySelector(".ais-InfiniteHits-loadMore");
  if (!window.GeometryAlgolia.canLoadMoreInstantSearchHits(button)) return;

  var scrollParent = window.GeometryAlgolia.getScrollParent(button);
  var observerKey = scrollParent === window ? "window" : scrollParent.className || scrollParent.tagName;

  if (window.GeometryAlgolia.infiniteHitsObserverKey === observerKey && button.dataset.geometryObserved === "true") {
    window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded();
    return;
  }

  if (window.GeometryAlgolia.infiniteHitsObserver) {
    window.GeometryAlgolia.infiniteHitsObserver.disconnect();
  }

  button.dataset.geometryObserved = "true";
  window.GeometryAlgolia.infiniteHitsObserverKey = observerKey;

  if ("IntersectionObserver" in window) {
    window.GeometryAlgolia.infiniteHitsObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            window.GeometryAlgolia.loadMoreInstantSearchHits(button);
          }
        });
      },
      {
        root: scrollParent === window ? null : scrollParent,
        rootMargin: "900px 0px",
      },
    );

    window.GeometryAlgolia.infiniteHitsObserver.observe(button);
  }

  window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded();
};

window.GeometryAlgolia.watchInstantSearchInfiniteHits = function () {
  if (window.GeometryAlgolia.infiniteHitsWatcherStarted || !document.body) return;

  window.GeometryAlgolia.infiniteHitsWatcherStarted = true;
  window.GeometryAlgolia.setupInstantSearchInfiniteObserver();

  var observer = new MutationObserver(function () {
    window.GeometryAlgolia.setupInstantSearchInfiniteObserver();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("scroll", window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded, true);
  window.addEventListener("resize", window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded);
};

window.GeometryAlgolia.getSearchPageQuery = function () {
  try {
    return new URLSearchParams(window.location.search).get("q") || "";
  } catch (error) {
    return "";
  }
};

window.GeometryAlgolia.normalizeInstantSearchPage = function () {
  if (!window.GeometryAlgolia.isInstantSearchTemplate()) return;

  var title = "Search Results";
  var isSearchTemplate = document.body.classList.contains("template-search");
  var heroContent = isSearchTemplate && document.querySelector(".geometry-search-hero__content");
  var facets = document.querySelector("#MainContent .shopify-app-block .ais-facets");
  var searchBox = document.querySelector("#MainContent .shopify-app-block .ais-input");
  var resultsBlock = document.querySelector("#MainContent .shopify-app-block .ais-block");
  var pagination = document.querySelector(
    "#MainContent .shopify-app-block .ais-pagination-container, #MainContent .shopify-app-block .ais-Pagination, #MainContent .shopify-app-block .ais-pagination",
  );
  var headings = document.querySelectorAll(
    "#MainContent .shopify-app-block h1, #MainContent .shopify-app-block h2, #MainContent .shopify-app-block .ais-title",
  );

  var heroTitleMoved = false;

  if (isSearchTemplate) {
    headings.forEach(function (heading) {
      var text = heading.textContent.replace(/\s+/g, " ").trim().toLowerCase();
      var isSearchTitle =
        text === "search result" ||
        text === "search results" ||
        text.indexOf("search result:") === 0 ||
        text.indexOf("search results:") === 0 ||
        heading.classList.contains("geometry-search-hero__title");

      if (!isSearchTitle) {
        return;
      }

      heading.textContent = title;

      if (heroContent) {
        var existingHeroTitle = heroContent.querySelector(".geometry-search-hero__title");

        if (existingHeroTitle && existingHeroTitle !== heading) {
          existingHeroTitle.remove();
        }

        heading.classList.add("geometry-search-hero__title");

        if (heading.parentElement !== heroContent) {
          heroContent.appendChild(heading);
        }

        heroTitleMoved = true;
      }
    });

    if (heroContent && !heroTitleMoved) {
      var existingHeroTitle = heroContent.querySelector(".geometry-search-hero__title");

      if (existingHeroTitle) {
        existingHeroTitle.textContent = title;
      }
    }
  }

  if (facets && searchBox && searchBox.parentElement !== facets) {
    searchBox.classList.add("geometry-ais-sidebar-search");
    facets.insertBefore(searchBox, facets.firstElementChild);
  }

  if (resultsBlock && pagination && pagination.parentElement !== resultsBlock) {
    resultsBlock.appendChild(pagination);
  }

  window.GeometryAlgolia.setupMobileFacetToggle();
  window.GeometryAlgolia.decorateColorFacets();

  document.querySelectorAll('#MainContent .shopify-app-block input[type="search"]').forEach(function (input) {
    if (!input.getAttribute("placeholder")) {
      input.setAttribute("placeholder", "Search Geometry");
    }
  });

  document.querySelectorAll("#MainContent .shopify-app-block .ais-Stats-text").forEach(function (stats) {
    var text = stats.textContent.replace(/\s+/g, " ").trim();
    var rangeMatch = text.match(/(\d+)\s*-\s*(\d+)\s*(?:out of|of)\s*([\d,]+)\s*results?/i);

    if (rangeMatch) {
      var rangeTotal = document.createElement("span");

      rangeTotal.className = "ais-stats--nb-results";
      rangeTotal.textContent = rangeMatch[3] + " results";
      stats.textContent = rangeMatch[1] + "-" + rangeMatch[2] + " of ";
      stats.appendChild(rangeTotal);
      return;
    }

    var countMatch = text.match(/([\d,]+)\s*results?/i);

    if (countMatch) {
      var total = document.createElement("span");

      total.className = "ais-stats--nb-results";
      total.textContent = countMatch[1] + " results";
      stats.textContent = "";
      stats.appendChild(total);
    }
  });
};

window.GeometryAlgolia.normalizeInstantSearchPageDeferred = function () {
  [0, 120, 400, 1000].forEach(function (delay) {
    window.setTimeout(window.GeometryAlgolia.normalizeInstantSearchPage, delay);
  });
};

window.GeometryAlgolia.watchInstantSearchPageNormalization = function () {
  if (window.GeometryAlgolia.instantSearchNormalizationWatcherStarted || !document.body) return;
  if (!window.GeometryAlgolia.isInstantSearchTemplate()) return;

  window.GeometryAlgolia.instantSearchNormalizationWatcherStarted = true;

  var observer = new MutationObserver(function () {
    window.clearTimeout(window.GeometryAlgolia.instantSearchNormalizationTimer);
    window.GeometryAlgolia.instantSearchNormalizationTimer = window.setTimeout(function () {
      window.GeometryAlgolia.normalizeInstantSearchPage();
      window.GeometryAlgolia.enhanceInstantSearchProductCards();
    }, 80);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

window.GeometryAlgolia.registerHooks = function () {
  if (window.GeometryAlgolia.hooksRegistered) return;
  if (!window.algoliaShopify || !window.algoliaShopify.hooks) return;

  window.GeometryAlgolia.hooksRegistered = true;
  var hooks = window.algoliaShopify.hooks;

  hooks.registerHook("beforeInstantSearchAsyncFunction", function () {
    window.GeometryAlgolia.installInstantSearchSearchBoxDebounce();
  });

  hooks.registerHook("beforeAutocompleteOptions", function (options) {
    var originalOnStateChange = options.onStateChange;
    var originalShouldPanelOpen = options.shouldPanelOpen;
    var headerPanelContainer = document.querySelector("[data-algolia-search-panel]");

    if (options.searchClient) {
      options.searchClient = window.GeometryAlgolia.wrapAutocompleteSearchClient(options.searchClient);
    }

    options.placeholder = "Search Geometry";
    options.openOnFocus = false;
    if (headerPanelContainer) options.panelContainer = headerPanelContainer;
    options.shouldPanelOpen = function (params) {
      var query = params && params.state ? params.state.query : "";

      if (!window.GeometryAlgolia.getNormalizedQuery(query)) return false;
      if (typeof originalShouldPanelOpen === "function") {
        return originalShouldPanelOpen.apply(this, arguments);
      }

      return true;
    };
    options.stallThreshold = window.GeometryAlgolia.autocompleteStallThresholdMs;
    options.onStateChange = function (params) {
      var state = params && params.state ? params.state : {};
      var query = state.query || "";
      var normalizedQuery = window.GeometryAlgolia.getNormalizedQuery(query);

      document.body.classList.toggle("geometry-algolia-search-query-active", Boolean(normalizedQuery));
      document.body.classList.toggle(
        "geometry-algolia-search-query-ready",
        window.GeometryAlgolia.isSearchQueryReady(normalizedQuery),
      );

      window.GeometryAlgolia.autocompleteRefresh = params && params.refresh;
      window.GeometryAlgolia.watchAutocompletePanelScroll();

      if (query !== window.GeometryAlgolia.autocompleteQuery) {
        window.GeometryAlgolia.autocompleteQuery = query;
        window.GeometryAlgolia.resetAutocompleteProductsLimit();
      }

      if (state.context && typeof state.context.nbProducts === "number") {
        window.GeometryAlgolia.autocompleteProductsCount = state.context.nbProducts;
      }

      if (window.GeometryAlgolia.isSearchQueryReady(query)) {
        window.setTimeout(window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded, 0);
        window.GeometryAlgolia.enhanceAutocompleteProductCardsDeferred();
      }

      if (typeof originalOnStateChange === "function") {
        return originalOnStateChange.apply(this, arguments);
      }
    };

    return options;
  });

  hooks.registerHook("beforeAutocompleteConfigurationOptions", function (config, context) {
    context = context || {};

    if (config.searchClient) {
      config.searchClient = window.GeometryAlgolia.wrapAutocompleteSearchClient(config.searchClient);
    }

    if (
      Array.isArray(config.queries) &&
      window.GeometryAlgolia.shouldShortCircuitAlgoliaRequests(config.queries)
    ) {
      config.queries = [];
    }

    if (context.pluginName !== "products" && context.sourceId !== "products") return config;
    if (!Array.isArray(config.queries)) return config;

    config.queries = config.queries.map(function (query) {
      return Object.assign({}, query, {
        params: Object.assign({}, query.params, {
          hitsPerPage: window.GeometryAlgolia.autocompleteProductsLimit,
          clickAnalytics: true,
        }),
      });
    });

    return config;
  });

  hooks.registerHook("beforeAutocompletePluginOptions", function (options, context) {
    context = context || {};

    if (options.searchClient) {
      options.searchClient = window.GeometryAlgolia.wrapAutocompleteSearchClient(options.searchClient);
    }

    if (!options.searchParameters) {
      options.searchParameters = {};
    }

    if (context.pluginName === "products") {
      options.searchParameters.hitsPerPage = window.GeometryAlgolia.autocompleteProductsStep;
      options.searchParameters.clickAnalytics = true;
    } else if (
      context.pluginName === "collections" ||
      context.pluginName === "articles" ||
      context.pluginName === "pages"
    ) {
      options.searchParameters.hitsPerPage = 3;
    }

    return options;
  });

  hooks.registerHook(
    "beforeAutocompleteMainTemplate",
    function (_defaultTemplate, templateOptions, elements) {
      var html = templateOptions.html;

      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable geometry-aa-panel">
          <div class="geometry-aa-panel__products geometry-aa-panel__products--only">
            ${elements.products}
          </div>
        </div>
      `;
    },
  );

  hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      var html = templateOptions.html;
      var item = templateOptions.item;
      var components = templateOptions.components;
      var image = window.GeometryAlgolia.getImage(item, 360);
      var secondaryImage = window.GeometryAlgolia.getSecondaryImage(item, 360, image);
      var productUrl = itemLink || window.GeometryAlgolia.getProductUrl(item);
      var productTitle = [item.title, item.product_type].filter(Boolean).join(" ");
      var variantId = window.GeometryAlgolia.getVariantId(item);
      var quickAddAvailable = item && (item.available === false || item.inventory_available === false) ? false : true;
      var productUid = String(variantId || item.id || item.handle || item.productPosition || "product").replace(
        /[^a-z0-9_-]/gi,
        "-",
      );
      var titleId = "geometry-aa-product-title-" + productUid;
      var quickAddId = "geometry-aa-quick-add-" + productUid;
      var trackProductClick = function () {
        trackSearchAttribution(item);
      };
      var stopQuickAddEvent = function (event) {
        event.stopPropagation();
      };

      return html`
        <div
          class="aa-ItemLink aa-ProductItem geometry-aa-product collection-product-card quickview--hover"
          data-algolia-index="${item.index || ""}"
          data-algolia-position="${item.productPosition || ""}"
          data-algolia-queryid="${item.queryID || ""}"
          data-algolia-objectid="${item.objectID || ""}"
          data-handle="${item.handle || ""}"
          data-variant-id="${variantId || ""}"
          data-distinct="${item._distinct || ""}"
          data-product-id="${item.id || ""}"
          data-product="${item.handle || ""}"
        >
          <div class="card-wrapper js-color-swatches-wrapper" data-product="${item.handle || ""}">
            <span class="visually-hidden">${productTitle}</span>
            <div class="card card--product" tabindex="-1">
              <div class="card__inner full-unstyled-link">
                <div
                  class="aa-ItemPicture aa-ItemPicture--loaded geometry-aa-product__picture media media--transparent media--hover-effect"
                >
                  ${
                    image
                      ? html`
                          <img
                            class="motion-reduce media--first"
                            src="${image.src}"
                            srcset="${image.srcset}"
                            sizes="${image.sizes}"
                            alt="${item.title || "Product image"}"
                            loading="lazy"
                          />
                          ${
                            secondaryImage &&
                            html`
                              <img
                                class="motion-reduce media--second"
                                src="${secondaryImage.src}"
                                srcset="${secondaryImage.srcset}"
                                sizes="${secondaryImage.sizes}"
                                alt="${secondaryImage.alt || item.title || "Product image"}"
                                loading="lazy"
                              />
                            `
                          }
                        `
                      : html`<span>${(item.title || "").slice(0, 1)}</span>`
                  }
                </div>
                ${
                  variantId &&
                  html`
                    <product-form
                      class="card__add-to-cart card__button geometry-aa-product__quick-add"
                      data-hide-errors="true"
                      onClick="${stopQuickAddEvent}"
                      onMouseDown="${stopQuickAddEvent}"
                    >
                      <form
                        method="post"
                        action="/cart/add"
                        class="form"
                        novalidate="novalidate"
                        data-type="add-to-cart-form"
                      >
                        <input type="hidden" name="id" value="${variantId}" disabled />
                        <input type="hidden" name="quantity" value="1" />
                        ${item.product_type && html`<input type="hidden" name="properties[Product type]" value="${item.product_type}" />`}
                        <button
                          id="${quickAddId}-submit"
                          type="submit"
                          class="card__link button button--primary mobile-button--primary card__link--hover card__link--show card-focused"
                          name="add"
                          aria-label="Add to Cart"
                          aria-haspopup="dialog"
                          aria-labelledby="${quickAddId}-submit ${titleId}"
                          aria-live="polite"
                          aria-disabled="${quickAddAvailable ? "false" : "true"}"
                          data-sold-out-message="true"
                          ${!quickAddAvailable && html`disabled`}
                        >
                          <span class="card__quickview-text ${quickAddAvailable ? "" : "hidden"}">Add to Cart</span>
                          <span class="sold-out-message ${quickAddAvailable ? "hidden" : ""}">Sold Out</span>
                          <div class="loading-overlay__spinner hidden">
                            <svg
                              aria-hidden="true"
                              focusable="false"
                              role="presentation"
                              class="spinner"
                              viewBox="0 0 66 66"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                          </div>
                        </button>
                      </form>
                    </product-form>
                  `
                }
              </div>
            </div>
            <div class="aa-ItemContent geometry-aa-product__content">
              <div class="aa-ItemContentBody geometry-aa-product__body card-information">
                <div class="card-information__wrapper">
                  <div class="card-information__group">
                    <h3 id="${titleId}" class="aa-ItemContentTitle geometry-aa-product__title card__title h5">
                      <a class="full-unstyled-link" href="${productUrl}" title="${productTitle}" onClick="${trackProductClick}">
                        ${components.Highlight({ hit: item, attribute: "title" })}
                        ${
                          item.product_type &&
                          html`
                            ${" "}
                            <span class="geometry-aa-product__title-type">
                              ${components.Highlight({ hit: item, attribute: "product_type" })}
                            </span>
                          `
                        }
                        <span class="algolia-variant">
                          ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                        </span>
                      </a>
                    </h3>
                    <div class="card-information__price-rating-row">
                      <div class="aa-ItemContentPrice geometry-aa-product__price price">
                        ${window.GeometryAlgolia.displayPriceNoDecimals(item, distinct)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a
              href="${productUrl}"
              class="link link--overlay card-wrapper__link--overlay js-color-swatches-link"
              aria-label="${productTitle}"
              onClick="${trackProductClick}"
            ></a>
          </div>
        </div>
      `;
    },
  );

  hooks.registerHook("beforeAutocompleteNoResultsTemplate", function (_defaultTemplate, templateOptions) {
    var html = templateOptions.html;
    var state = templateOptions.state || {};
    var normalizedQuery = window.GeometryAlgolia.getNormalizedQuery(state.query);
    var query = encodeURIComponent(normalizedQuery);

    if (!window.GeometryAlgolia.isSearchQueryReady(normalizedQuery)) {
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable geometry-aa-panel geometry-aa-no-results geometry-aa-no-results--short-query">
          <div class="geometry-aa-no-results__links" aria-label="Shop by category">
            ${window.GeometryAlgolia.categoryLinks.map(function (link) {
              return html`
                <a class="geometry-aa-no-results__link" href="${window.GeometryAlgolia.getThemeRoute(link.path)}">
                  <span class="geometry-aa-no-results__thumb">
                    <img
                      src="${window.GeometryAlgolia.getShopFileImage(link.image, 240)}"
                      alt=""
                      loading="lazy"
                      aria-hidden="true"
                    />
                  </span>
                  <span>${link.label}</span>
                </a>
              `;
            })}
          </div>
        </div>
      `;
    }

    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable geometry-aa-panel geometry-aa-no-results">
        <div class="geometry-aa-no-results__copy">
          <h2 class="geometry-aa-no-results__title">No results for "${normalizedQuery}"</h2>
          <p class="geometry-aa-no-results__text">
            Try one of our most-shopped categories, or browse everything.
          </p>
        </div>

        <div class="geometry-aa-no-results__links" aria-label="Shop by category">
          ${window.GeometryAlgolia.categoryLinks.map(function (link) {
            return html`
              <a class="geometry-aa-no-results__link" href="${window.GeometryAlgolia.getThemeRoute(link.path)}">
                <span class="geometry-aa-no-results__thumb">
                  <img
                    src="${window.GeometryAlgolia.getShopFileImage(link.image, 240)}"
                    alt=""
                    loading="lazy"
                    aria-hidden="true"
                  />
                </span>
                <span>${link.label}</span>
              </a>
            `;
          })}
        </div>

        <a
          class="geometry-aa-no-results__all"
          href="${window.GeometryAlgolia.getThemeRoute("search")}?q=${query}"
        >
          See all products
        </a>
      </div>
    `;
  });

  hooks.registerHook(
    "beforeAutocompleteCollectionsTemplate",
    function (_defaultTemplate, templateOptions, itemLink) {
      var html = templateOptions.html;
      var item = templateOptions.item;
      var components = templateOptions.components;
      var collectionImage = item.image ? window.GeometryAlgolia.getImage(item, 160) : null;
      var productCountLabel = item.products_count === 1 ? "product" : "products";

      return html`
        <a href="${itemLink}" class="aa-ItemLink geometry-aa-collection">
          <div class="aa-ItemContent geometry-aa-collection__content">
            <div class="geometry-aa-collection__image">
              ${
                collectionImage
                  ? html`
                      <img
                        src="${collectionImage.src}"
                        srcset="${collectionImage.srcset}"
                        sizes="${collectionImage.sizes}"
                        alt="${item.title || "Collection image"}"
                        loading="lazy"
                      />
                    `
                  : html`<span>${(item.title || "").slice(0, 1)}</span>`
              }
            </div>
            <div class="aa-ItemContentBody geometry-aa-collection__body">
              <div class="aa-ItemContentTitle geometry-aa-collection__title">
                ${components.Highlight({ hit: item, attribute: "title" })}
              </div>
              ${
                item.products_count &&
                html`
                  <div class="geometry-aa-collection__count">
                    ${algoliaShopify.helpers.formatNumber(item.products_count)} ${productCountLabel}
                  </div>
                `
              }
            </div>
          </div>
        </a>
      `;
    },
  );

  hooks.registerHook("beforeAutocompleteFooterTemplate", function (_defaultTemplate, templateOptions) {
    var html = templateOptions.html;
    var state = templateOptions.state;
    var query = encodeURIComponent(state.query || "");

    return html`
      <div class="aa-footer geometry-aa-footer">
        <a class="aa-SeeAllBtn geometry-aa-see-all" href="${window.Shopify.routes.root}search?q=${query}">
          See all results
          (${algoliaShopify.helpers.formatNumber(state.context.nbProducts || 0)})
        </a>
      </div>
    `;
  });

  hooks.registerHook("beforeInstantSearchConfigurationOptions", function (options) {
    options.stalledSearchDelay = 300;
    return options;
  });

  hooks.registerHook("beforeInstantSearchOptions", function (options) {
    options.hitsPerPage = 12;
    return options;
  });

  hooks.registerHook("beforeInstantSearchProductTemplate", function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
    return window.GeometryAlgolia.renderInstantSearchProduct(hit, html, components, trackSearchAttribution);
  });

  hooks.registerHook("beforeInstantSearchFacetParamsOptions", function (params, facet) {
    params = window.GeometryAlgolia.addFacetRootClassNames(
      params,
      window.GeometryAlgolia.getFacetVisibilityClassNames(facet)
    );

    if (facet.type === "slider") {
      return Object.assign({}, params, {
        pips: false,
        tooltips: true,
      });
    }

    if (facet.name === "tags" || facet.title === "Tags") {
      return Object.assign({}, params, {
        limit: 12,
        showMore: true,
        showMoreLimit: 40,
        searchable: true,
      });
    }

    if (facet.type === "conjunctive" || facet.type === "disjunctive") {
      return Object.assign({}, params, {
        limit: 10,
        showMore: true,
        showMoreLimit: 32,
      });
    }

    return params;
  });

  hooks.registerHook("beforeInstantSearchFacetPanelOptions", function (params, facet) {
    return window.GeometryAlgolia.addFacetRootClassNames(
      params,
      window.GeometryAlgolia.getFacetVisibilityClassNames(facet)
    );
  });
};

document.addEventListener("algolia.hooks.initialize", window.GeometryAlgolia.registerHooks);
document.addEventListener("algolia.instantSearch.afterRender", function () {
  window.GeometryAlgolia.setupInstantSearchInfiniteObserver();
  window.GeometryAlgolia.watchInstantSearchPageNormalization();
  window.GeometryAlgolia.normalizeInstantSearchPageDeferred();
  window.GeometryAlgolia.enhanceInstantSearchProductCardsDeferred();
});
document.addEventListener("DOMContentLoaded", function () {
  window.GeometryAlgolia.watchInstantSearchPageNormalization();
  window.GeometryAlgolia.normalizeInstantSearchPageDeferred();
  window.GeometryAlgolia.enhanceInstantSearchProductCardsDeferred();
});
window.GeometryAlgolia.normalizeInstantSearchPageDeferred();
window.GeometryAlgolia.enhanceInstantSearchProductCardsDeferred();
window.GeometryAlgolia.registerHooks();
